
export default {
  name: 'PageBrochureBookIndex',

  head() {
    return {
      title: `Book`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Book a session at Paw Paddock`
        }
      ]
    }
  }
}
